// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M 8 1.5 C 5.85 1.5 4.1 3.25 4.1 5.4 C 4.1 7.62 5.53 9.16 6.83 10.47 C 7.48 11.13 8.52 11.13 9.17 10.47 C 10.47 9.16 11.9 7.62 11.9 5.4 C 11.9 3.25 10.15 1.5 8 1.5 Z',
  'M9.35 5.4C9.35 6.15 8.75 6.75 8 6.75C7.25 6.75 6.65 6.15 6.65 5.4C6.65 4.65 7.25 4.05 8 4.05C8.75 4.05 9.35 4.65 9.35 5.4Z',
  'M3.6 9.5C3.22 9.5 2.91 9.77 2.77 10.16L1.59 13.24C1.35 13.89 1.8 14.5 2.48 14.5H13.52C14.2 14.5 14.65 13.89 14.41 13.24L13.23 10.16C13.09 9.77 12.78 9.5 12.4 9.5',
];
